module.exports = __webpack_public_path__ + "img/28.7b53bb8b.gif";